module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("chooseOrganizationView.title")))]), _vm._v(" "), _c('ul', _vm._l((_vm.store.currentUser.organizations), function(o) {
    return (_vm.userOrganizationEventCount(o) > 0) ? _c('li', {
      key: o.organizationId,
      staticClass: "list-item clickable",
      on: {
        "click": function($event) {
          _vm.chooseOrganization(o)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(o.name))])]) : _c('li', {
      staticClass: "list-item disabled"
    }, [_c('h3', [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("chooseOrganizationView.noEvents")))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1883c8e1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/ChooseOrganizationView.vue
// module id = 110
// module chunks = 0